import React from "react"

import { EntityValidationPage } from "../YamlValidation"

const MarkDownPreview=()=>{
  return <EntityValidationPage from="markDownPreview"/>
}

export default MarkDownPreview;